import React from 'react';

import { cn } from '@/lib/utils';

export type PageTransitionProps = {
  children: React.ReactNode;
  duration?: number;
  type?: 'fade' | 'slide' | 'scale' | 'none';
  className?: string;
};

function PageTransition({
  children,
  duration = 300,
  type = 'fade',
  className,
}: PageTransitionProps) {
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    });
  }, []);

  const getAnimationStyles = () => {
    if (type === 'none') return '';

    const baseClasses = 'transition-all ease-out';
    const durationClass = `duration-[${duration}ms]`;

    if (!isVisible) {
      switch (type) {
        case 'fade':
          return `${baseClasses} ${durationClass} opacity-0 translate-y-1`;
        case 'slide':
          return `${baseClasses} ${durationClass} opacity-0 translate-y-3`;
        case 'scale':
          return `${baseClasses} ${durationClass} opacity-0 scale-[0.99]`;
        default:
          return `${baseClasses} ${durationClass} opacity-0 translate-y-1`;
      }
    }
    return `${baseClasses} ${durationClass} opacity-100 translate-y-0 scale-100`;
  };

  return <div className={cn(getAnimationStyles(), className)}>{children}</div>;
}

export { PageTransition };
export default PageTransition;
